<template>
    <svg
        class="svg-icon svg-icon-alert-circle"
        viewBox="0 0 24 24"
        x="0px"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        y="0px">
        <g
            fill="#adb5bd"
            stroke="#adb5bd"
            stroke-linecap="square"
            stroke-linejoin="miter"
            stroke-width="2">
            <circle
                cx="12"
                cy="12"
                fill="none"
                r="11"
                stroke="#adb5bd"
                stroke-miterlimit="10"/>
            <line
                data-color="color-2"
                fill="none"
                stroke-miterlimit="10"
                x1="12"
                x2="12"
                y1="7"
                y2="13"/>
            <circle
                cx="12"
                cy="17"
                data-color="color-2"
                data-stroke="none"
                r="1"
                stroke="none"
                stroke-linecap="square"
                stroke-linejoin="miter"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'InformationSvg',
};
</script>
